export const AUTOMATED_LABEL_KEYS: Record<string, string> = Object.freeze({
  ActiveSeeker: 'ActiveSeeker',
  PassiveSeeker: 'PassiveSeeker',
  HasLicense: 'HasLicense',
  HasRelevantLicense: 'HasRelevantLicense',
  HasRequiredExperience: 'HasRequiredExperience',
  HasResume: 'HasResume',
  ApplicantSpecial: 'ApplicantSpecial',
  HighExpectations: 'HighExpectations',
  IsFarAway: 'IsFarAway',
  JobHopper: 'JobHopper',
  Responsive: 'Responsive',
  FullTimePartTimeMismatch: 'FullTimePartTimeMismatch',
  MightBeMoving: 'MightBeMoving',
});

export const AUTOMATED_LABEL_KEY_DESCRIPTIONS: Record<string, string> = Object.freeze({
  ActiveSeeker:
    'An active applicant is one who is searching for a job and found this posting on a job board',
  PassiveSeeker: 'A passive applicant is someone who clicked on an ad on a non-job-board website',
  HasRequiredExperience: 'This applicant has all required experience',
  HasLicense: 'This applicant has all required licenses',
  HasRelevantLicense: 'This applicant has at least one relevant license',
  HasResume: 'This applicant has provided their resume',
  ApplicantSpecial: 'A detailed applicant is one who took the time to provide a lot of information',
  HighExpectations:
    'An applicant with high expectations is one who gave an expected compensation that was much higher than the range for your job ($5/hr more for hourly and 20% more for salaried jobs).',
  IsFarAway:
    'An applicant that may have a hard time getting to work. By default, applicants receive this label if their commute longer than 1 hour, but you can configure a custom time or distance.',
  JobHopper:
    'An applicant is a job hopper if they are unlikely to be a student, they have more than 1 job in their history, and the average tenure in the past 3 years is less than year.',
  Responsive: 'A responsive applicant is one that has responded to at least one message.',
  FullTimePartTimeMismatch:
    'The job requirement and applicant desires for full-time or part-time work do not match',
  MightBeMoving:
    'An applicant with this label lives more than 3 hours away and might be considering relocating',
});

export const AUTOMATED_LABEL_KEY_NEGATIVE_DISPLAY_NAME: Record<string, string> = Object.freeze({
  ActiveSeeker: '',
  PassiveSeeker: '',
  HasLicense: 'Missing required license',
  HasRelevantLicense: "Doesn't have any licenses",
  HasRequiredExperience: 'Missing required experience',
  HasResume: 'No resume provided',
  ApplicantSpecial: 'Insufficient detail',
  HighExpectations: '',
  IsFarAway: '',
  JobHopper: '',
  Responsive: 'Not Responsive',
  FullTimePartTimeMismatch: '',
  MightBeMoving: '',
});
